export default "__VITE_ASSET___19O6AVY__"